/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HeaderFooterContent } from '../../models/header-footer-content';
import { HeaderFooterContentApiRespModel } from '../../models/header-footer-content-api-resp-model';

export interface ApiMasterHeaderFooterIconEditHeaderFooterPost$Params {
      body?: HeaderFooterContent
}

export function apiMasterHeaderFooterIconEditHeaderFooterPost(http: HttpClient, rootUrl: string, params?: ApiMasterHeaderFooterIconEditHeaderFooterPost$Params, context?: HttpContext): Observable<StrictHttpResponse<HeaderFooterContentApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterHeaderFooterIconEditHeaderFooterPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HeaderFooterContentApiRespModel>;
    })
  );
}

apiMasterHeaderFooterIconEditHeaderFooterPost.PATH = '/api/Master/HeaderFooterIcon/EditHeaderFooter';
